import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgPh48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Phillipines",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "m4.64 5.23 7 8.54L22 12A10 10 0 0 0 4.64 5.23"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M22 12a10 10 0 0 1-17.35 6.78L10.2 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.93 19.07 12 12 4.93 4.93a10 10 0 0 0 0 14.14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "m8.85 12-1.22-.57.65-1.19L7 10.5l-.22-1.34-.92 1-.93-1-.17 1.34-1.33-.26.66 1.19-1.22.57 1.22.57-.64 1.19 1.32-.26.17 1.34.92-1 .93 1L7 13.5l1.33.26-.65-1.19zM4.67 5.91l.4.57.67-.21-.42.56.41.57-.66-.22-.41.56V7L4 6.82l.66-.21zm0 10.35.4.57.67-.21-.42.56.41.57-.66-.23-.41.57v-.7L4 17.17l.66-.17zm5.8-5.17-.41.56-.67-.21.41.56-.4.57.66-.22.42.56v-.7l.67-.22-.67-.21z"
}));

export { SvgPh48Rounded as default };
//# sourceMappingURL=Ph48Rounded.js.map
